module.exports = __webpack_public_path__ + "static/media/mgs2018logo.4b0c8453.svg";